import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";
import { getSetting, MemberData, PageContent, setPathLayout } from "../actions/Utils";
import Common from '../components/Member/layout/Common';




class MemberLayout extends Component {
    constructor(props) {
        super(props);
        this.state = {
            path:'',
            header:{},
            container:{},
            footer:{},
            layout_id:'',
            page_content:{},
            member_data:{}
        };
    }
    componentDidMount = () => {
        window.scroll({ top: 0, left: 0, behavior: 'smooth' });

        const {location} = this.props.history;
        const slug = this.props.match.path.replace('/','');

        this.props.PageContent(slug).then((res)=>{

        });

        this.props.MemberData().then((res)=>{
            this.setState({
                member_data:res
              })
        });
    }

    render() {
        const {page_data}=this.props.page_content.content;
        const member_data=this.state.member_data;
        if(page_data && member_data.length >0)
        {
            return (
                <Fragment>
                    {
                        
                        <Common page_data={page_data} member={member_data}/>
                    }
                    
                </Fragment>
            )
        }
        return (
            <Fragment>
                
            </Fragment>
        )
    }
}

const mapStateToProps = state => ({
    page_content:state.contents.page_content,
    utils:state.utils,
    header:state.header,
    contents:state.contents,
    footer:state.footer,
    layout_id:state.utils.layout_id,
    routemenu:state.utils.routemenu,
    setting:state.utils.setting,
    
})

const mapDispatchToProps = dispatch => ({
    getSetting:() =>dispatch(getSetting()),
    setPathLayout:(requestData) =>dispatch(setPathLayout(requestData)),
    PageContent: (requestData) => dispatch(PageContent(requestData)),
    MemberData: (requestData) => dispatch(MemberData(requestData)),
})

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(MemberLayout));